import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Terms of Service</h1>
          <p className="text-slate-500 mb-10 pb-6 border-b border-slate-100">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <div className="space-y-8 text-slate-600 leading-relaxed font-light">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the website of Toptier Ventures ("we," "us," or "our"), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you must not use our website or services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Description of Service</h2>
              <p>
                Toptier Ventures is a real estate investment firm. We provide a platform for landowners to submit property information to receive a cash offer. 
                <strong> Important:</strong> Any offer generated or communicated through this website, via email, or via SMS is preliminary and non-binding until a formal, written Purchase and Sale Agreement is signed by both parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. User Responsibilities</h2>
              <p className="mb-3">When using our service to request an offer, you agree that:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>You are the legal owner of the property being submitted, or you have the legal authority to sell it.</li>
                <li>All information provided regarding the property is accurate, truthful, and complete to the best of your knowledge.</li>
                <li>You will not use our website for any fraudulent or unlawful purpose.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Intellectual Property</h2>
              <p>
                All content, logos, graphics, and text on this website are the property of Toptier Ventures and are protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our explicit written consent.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Limitation of Liability</h2>
              <p>
                Toptier Ventures shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to, or use of, our website and services. We do not guarantee that our website will be error-free or uninterrupted.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Modifications</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. Any changes will be effective immediately upon posting on this page. Your continued use of our website constitutes your acceptance of the revised terms.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;